import {BaseOptions} from "../../../dialog/options/base.options";

export class SelectUserOptions extends BaseOptions {
  userType?: string;
  onUserSelected = (user: any) => {
  };
}
